module.exports = __webpack_public_path__ + "static/media/solution-1-big.f973a5da.png";